import React, { useState } from "react";
import "../../assets/styles/table.css";
import { FiEye, FiEdit2, FiTrash2 } from "react-icons/fi";
import { IInventory } from "../../types";
import { inventoryColumns } from "../../constants/constants";
import { useGetInventoryListQuery } from "../../store/api/inventoryApi";
import Pagination from "rc-pagination";

const TableInventory: React.FC<{
  onView?: (row: IInventory) => void;
  pageNumber: number;
  setTotalCount: (count: number) => void;
  searchValue?: string;
}> = ({ onView, pageNumber, setTotalCount, searchValue = "" }) => {
  const { data: inventoryData, isLoading: inventoryLoading } =
    useGetInventoryListQuery({ page: pageNumber, search: searchValue });
  React.useEffect(() => {
    setTotalCount(inventoryData?.data?.totalCount || 0);
  }, [inventoryData, setTotalCount]);
  // Filter logic

  return (
    <div className="tableWrapper">
      <table className="table">
        <thead>
          <tr>
            {inventoryColumns.map((col) => (
              <th key={col.key} data-column={col.key}>
                {col.label}
              </th>
            ))}
            <th></th>
          </tr>
        </thead>
      </table>
      <div className="tableBodyWrapper">
        <table className="table">
          <tbody>
            {inventoryLoading ? (
              <tr>
                <td colSpan={inventoryColumns.length + 1}>Loading...</td>
              </tr>
            ) : inventoryData?.data?.inventory.length === 0 ? (
              <tr>
                <td colSpan={inventoryColumns.length + 1}>No data found.</td>
              </tr>
            ) : (
              inventoryData?.data?.inventory.map((row: IInventory) => (
                <tr key={row.id}>
                  {inventoryColumns.map((col) => (
                    <td key={col.key} data-column={col.key}>
                      {row[col.key as keyof IInventory]}
                    </td>
                  ))}
                  <td className="actionCell">
                    <button
                      className="actionButton"
                      onClick={() => onView?.(row)}
                      title="View"
                    >
                      <FiEye />
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TableInventory;
